// extracted by mini-css-extract-plugin
export var completionBody = "_ej-2";
export var completionCard = "_ej-0";
export var completionFooter = "_ej-3";
export var completionTitle = "_ej-1";